import orderBy from 'lodash/orderBy';
import { Order } from '../QueryResultSimulation';
import { trimAddedItemsFromPagePredicate } from './trimAddedItemsFromPagePredicate';

export function orderByOrders<T>(
  pageWithPatchedItems: { item: T; orderByItem?: T }[],
  toMerge: {
    all: Map<string, { item: T; keepPosition?: boolean }>;
    created: Map<string, { item: T; keepPosition?: boolean }>;
  },
  {
    limit,
    itemKey,
    orders,
  }: {
    limit: number;
    itemKey: (item: T) => string;
    orders: Order<T>[];
  },
): T[] {
  const pageWithPatchedItemsOrdered = orders.length
    ? orderBy(
        pageWithPatchedItems,
        orders.map(({ fieldName }) => {
          const fn =
            typeof fieldName === 'function'
              ? fieldName
              : (e: T) => e[fieldName as keyof T];
          return ({ item, orderByItem }, index) => {
            const finalItem = orderByItem ?? item;
            return fn(finalItem, index);
          };
        }),
        orders.map(({ order }) => order),
      )
    : pageWithPatchedItems;

  return pageWithPatchedItemsOrdered
    .map(({ item }) => item)
    .filter(
      trimAddedItemsFromPagePredicate({
        addedItems: toMerge.all,
        itemKey,
        limit,
      }),
    );
}
